'use client';

import { ProductHomecreditCalculator } from '@eliadmin/core/src/components/product/detail/homecredit/product-homecredit-calculator';
import { ProductPromotions } from '@eliadmin/core/src/components/product/detail/product-promotions';
import { ProductQuantityDiscounts } from '@eliadmin/core/src/components/product/detail/product-quantity-discount';
import { useGlobalStore } from '@eliadmin/core/src/stores/global-store';
import { useVariantsStore } from '@eliadmin/core/src/stores/variant-store';
import { getProductPriceDisplay } from '@eliadmin/core/src/utils/product-price-utils';

/**
 * Quantity discounts, promotions and the Home Credit calculator – placed under the cart row. Same
 * conditions as the core `ProductPurchaseSection`: nothing for ended / arriving products and for
 * products with the price on request, no calculator while a variant still has to be chosen.
 */
export function ProductPurchaseExtras() {
  const homecredit = useGlobalStore(state => state.apiKeys?.homecredit);
  const product = useVariantsStore(state => state.product);
  const selectedVariant = useVariantsStore(state => state.selectedVariant);
  const isWaitingForVariant = (product.variants?.length ?? 0) > 0 && !selectedVariant;
  const priceDisplay = getProductPriceDisplay(selectedVariant ?? product);
  const priceOnRequest = !isWaitingForVariant && priceDisplay.priceOnRequest;
  const hasSpecialProductStatus = product.status === 'ended' || product.status === 'arrival';

  if (hasSpecialProductStatus || priceOnRequest) return null;

  return (
    <div className="flex flex-col gap-4 empty:hidden" data-section="product-purchase-extras">
      <ProductQuantityDiscounts />
      <ProductPromotions />
      {!isWaitingForVariant && priceDisplay.currentWithVat != null ? (
        <ProductHomecreditCalculator homecredit={homecredit} price={priceDisplay.currentWithVat} />
      ) : null}
    </div>
  );
}
